<template>
  <div class="content-layout">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ContentLayout"
};
</script>

<style lang="scss" scoped>
.content-layout {
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  position: relative;
  text-align: center;
  width: 100%;
  z-index: z-index("emphasized");
}
</style>
